import React from 'react';
import { Icon, Modal, Table } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { contentTypes, contentTypesList } from '@utils';

const confirmDuplicateModal = (t, onOk, onCancel = () => false) =>
  Modal.confirm({
    cancelText: t('pathways:ProcedurePathways.duplicatePathway.cancel'),
    className: 'procedure-pathways-modal',
    okText: t('pathways:ProcedurePathways.duplicatePathway.ok'),
    title: t('pathways:ProcedurePathways.duplicatePathway.title'),
    icon: <Icon type="exclamation-circle" theme="filled" />,
    width: 634,
    onCancel,
    onOk: () => onOk(),
    content: (
      <>
        <p>{t('pathways:ProcedurePathways.duplicatePathway.helpText1')}</p>
        <Table
          bordered
          columns={[
            {
              title: <b>{t('pathways:ProcedurePathways.duplicatePathway.what')}</b>,
              key: 'what-column',
              dataIndex: 'what',
            },
            {
              title: <b>{t('pathways:ProcedurePathways.duplicatePathway.action')}</b>,
              key: 'action-column',
              dataIndex: 'action',
            },
          ]}
          dataSource={[
            {
              what: (
                <p>
                  <b>{t('pathways:ProcedurePathways.duplicatePathway.whatGroups')}</b>
                </p>
              ),
              action: t('pathways:ProcedurePathways.duplicatePathway.referenceGroupsAction'),
              key: 'what-1',
            },
            {
              what: (
                <p>
                  <b>{t('pathways:ProcedurePathways.duplicatePathway.whatRules')}</b>
                </p>
              ),
              action: t('pathways:ProcedurePathways.duplicatePathway.duplicateAction'),
              key: 'what-2',
            },
            {
              what: (
                <div>
                  <p>
                    <b>{t('pathways:ProcedurePathways.duplicatePathway.whatContent')}</b>
                  </p>
                  {contentTypesList.map(type => (
                    <p key={type}>
                      <FontAwesomeIcon icon={contentTypes[type].icon} />{' '}
                      {t(contentTypes[type].label)}
                    </p>
                  ))}
                </div>
              ),
              action: t('pathways:ProcedurePathways.duplicatePathway.referenceContentAction'),
              key: 'what-3',
            },
          ]}
          pagination={false}
        />
        <p>{t('pathways:ProcedurePathways.duplicatePathway.helpText2')}</p>
      </>
    ),
  });

export default confirmDuplicateModal;
